import * as React from 'react';

export interface ErrorMessagesComponentProps {
  errorMessage: {};
}

const ErrorMessagesComponent = (props: ErrorMessagesComponentProps) => {

  const getMessages = (messages: {}): React.ReactNode[] => {
    const tips: React.ReactNode[] = [];
    const messageKeys = Object.keys(messages);

    messageKeys.forEach((key) => {
      tips.push(
        <div key={key}>
          <span
            className="arrow-right-primary-dark"
          />
          {messages[key] || key}
        </div>
      );
    });

    return tips;
  };

  return (
    <div
      style={{color: 'Red'}}
    >
      {getMessages(props.errorMessage)}
    </div>
  );
};

export default ErrorMessagesComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/error-messages/ErrorMessages.component.tsx